{
  "name": "Burg",
  "ambient": 8220268,
  "light": 16771304,
  "sky": 14141126,
  "fog": 13812161,
  "fogD": 918.7540927106669,
  "camPos": [11, 33, -217],
  "spawns": [[-80, 18, 35, 0, 0, 0], [177, 0, -188, 0, 0, 0], [215, 10, -504, 0, 1, 0], [-169, 2, -514, 0, 2, 0], [-328, 0, -255, 0, 0, 0], [-154, 0, -134, 0, 1, 0], [-125, -28, -341, 0, 0, 0], [32, -28, -509, 0, 1, 0], [331, 0, -227, 0, 2, 0], [102, 0, -365, 0, 0, 0]],
  "ambO": 0.7,
  "ambS": 5,
  "modes": [0, 1],
  "shadScale": 170,
  "objects": [{
    "p": [-96, 16, 41],
    "s": [288, 2, 62],
    "t": 1
  }, {
    "p": [73, 0, 33],
    "s": [50, 18, 46],
    "i": 9,
    "t": 1,
    "d": 2
  }, {
    "p": [28, 0, 8],
    "s": [152, 24, 4]
  }, {
    "p": [0, -2, -71],
    "s": [516, 2, 252],
    "t": 1
  }, {
    "p": [-76, 0, -48],
    "s": [56, 74, 122],
    "bo": 1
  }, {
    "p": [37, 0, -68],
    "s": [110, 54, 80],
    "bo": 1
  }, {
    "p": [-112, 0, 74],
    "s": [126, 76, 38],
    "bo": 1
  }, {
    "p": [90, 0, 77],
    "s": [158, 76, 44],
    "bo": 1
  }, {
    "p": [-136, 16, -16],
    "s": [64, 2, 52],
    "t": 1
  }, {
    "p": [-136, 0, -44],
    "s": [64, 24, 4]
  }, {
    "p": [-170, 0, -18],
    "s": [4, 24, 56]
  }, {
    "p": [-234, 0, -27],
    "s": [32, 60, 97],
    "bo": 1
  }, {
    "p": [-258, 18, 41],
    "s": [47, 32, 44],
    "c": 13619151,
    "bo": 1
  }, {
    "p": [-218, 13, 74],
    "s": [88, 38, 54],
    "bo": 1
  }, {
    "p": [185, 0, -9],
    "s": [16, 67, 84],
    "bo": 1
  }, {
    "p": [180, 0, 45],
    "s": [60, 92, 44],
    "c": 11842740,
    "bo": 1
  }, {
    "p": [213, 0, -61],
    "s": [94, 92, 60],
    "c": 11645361,
    "bo": 1
  }, {
    "p": [96, 0, -175],
    "s": [110, 44, 44],
    "bo": 1
  }, {
    "p": [-85, 0, -140],
    "s": [56, 84, 112],
    "bo": 1
  }, {
    "p": [126, -4, -300],
    "s": [228, 4, 206],
    "t": 1
  }, {
    "p": [-82, -28, -252],
    "s": [60, 94, 138],
    "bo": 1
  }, {
    "p": [9, -28, -274],
    "s": [6, 34, 168]
  }, {
    "p": [49, -28, -385],
    "s": [96, 104, 68],
    "bo": 1
  }, {
    "p": [-23, -28, -252],
    "s": [58, 28, 110],
    "i": 9,
    "t": 1,
    "d": 1
  }, {
    "p": [59, -32, -452],
    "s": [218, 4, 138],
    "t": 1
  }, {
    "p": [-108, -28, -377],
    "s": [130, 88, 42],
    "bo": 1
  }, {
    "p": [-21, 6, -377],
    "s": [44, 38, 20],
    "bo": 1
  }, {
    "p": [-243, 0, -105],
    "s": [21, 50, 96],
    "c": 12302777,
    "bo": 1
  }, {
    "p": [190, 0, -346],
    "s": [117, 58, 118],
    "bo": 1
  }, {
    "p": [-195, 0, -17],
    "s": [46, 18, 54],
    "i": 9,
    "t": 1,
    "d": 1
  }, {
    "p": [-134, 0, -191],
    "s": [90, 77, 76],
    "bo": 1
  }, {
    "p": [-278, 0, -191],
    "s": [130, 77, 76],
    "bo": 1
  }, {
    "p": [-227, -2, -254],
    "s": [232, 2, 50],
    "t": 1
  }, {
    "p": [-210, -28, -323],
    "s": [132, 90, 66],
    "bo": 1
  }, {
    "p": [-128, -28, -300],
    "s": [32, 28, 42],
    "i": 9,
    "t": 1,
    "d": 1
  }, {
    "p": [-233, -2, -419],
    "s": [172, 2, 280],
    "t": 1
  }, {
    "p": [-326, -22, -321],
    "s": [34, 84, 88],
    "bo": 1
  }, {
    "p": [-370, -2, -253],
    "s": [55, 155, 58],
    "bo": 1
  }, {
    "p": [-158, -28, -274],
    "s": [28, 90, 32],
    "bo": 1
  }, {
    "p": [-263, -20, -322],
    "s": [30, 94, 94],
    "bo": 1
  }, {
    "p": [-330, -23, -394],
    "s": [22, 81, 210],
    "bo": 1
  }, {
    "p": [-88, -28, -429],
    "s": [78, 28, 62],
    "i": 9,
    "t": 1,
    "d": 2
  }, {
    "p": [-103, -22, -497],
    "s": [49, 84, 86],
    "bo": 1
  }, {
    "p": [-137, -2, -463],
    "s": [20, 2, 130],
    "t": 1
  }, {
    "p": [-164, 0, -547],
    "s": [98, 86, 40],
    "bo": 1
  }, {
    "p": [-283, 0, -506],
    "s": [72, 10, 86],
    "t": 1
  }, {
    "p": [-261, 0, -452],
    "s": [28, 10, 22],
    "t": 1
  }, {
    "p": [-298, 0, -450],
    "s": [42, 10, 26],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [-347, 0, -535],
    "s": [72, 72, 76],
    "bo": 1
  }, {
    "p": [-262, 0, -567],
    "s": [98, 52, 40],
    "bo": 1
  }, {
    "p": [-319, 0, -587],
    "s": [48, 139, 54],
    "c": 11645361
  }, {
    "p": [-1, -28, -377],
    "s": [4, 34, 20],
    "bo": 1
  }, {
    "p": [-41, -28, -377],
    "s": [4, 34, 20],
    "bo": 1
  }, {
    "p": [-63, -28, -506],
    "s": [52, 118, 92],
    "bo": 1
  }, {
    "p": [85, -28, -498],
    "s": [32, 112, 88],
    "bo": 1
  }, {
    "p": [173, 8, -503],
    "s": [148, 2, 84],
    "t": 1
  }, {
    "p": [39, -29, -544],
    "s": [218, 94, 46],
    "bo": 1
  }, {
    "p": [182, 10, -540],
    "s": [72, 87, 60],
    "bo": 1
  }, {
    "p": [292, -4, -329],
    "s": [104, 4, 264],
    "t": 1
  }, {
    "p": [280, 0, -485],
    "s": [58, 10, 48],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [278, 8, -527],
    "s": [62, 2, 36],
    "t": 1
  }, {
    "p": [264, 9, -558],
    "s": [94, 36, 26],
    "bo": 1
  }, {
    "p": [331, -23, -552],
    "s": [54, 135, 110],
    "c": "#aaaaaa",
    "bo": 1
  }, {
    "p": [332, 0, -499],
    "s": [48, 55, 110],
    "bo": 1
  }, {
    "p": [342, 1, -411],
    "s": [20, 31, 110],
    "bo": 1
  }, {
    "p": [336, 0, -303],
    "s": [54, 61, 110],
    "bo": 1
  }, {
    "p": [127, -28, -425],
    "s": [64, 35, 4]
  }, {
    "p": [196, -28, -461],
    "s": [110, 44, 4]
  }, {
    "p": [249, 0, -486],
    "s": [4, 16, 46]
  }, {
    "p": [204, -28, -440],
    "s": [72, 28, 38],
    "i": 9,
    "t": 1
  }, {
    "p": [156, 0, -188],
    "s": [32, 70, 82],
    "bo": 1
  }, {
    "p": [228, 0, -188],
    "s": [32, 86, 82],
    "bo": 1
  }, {
    "p": [367, 0, -146],
    "s": [58, 50, 118],
    "c": "#a2a2a2",
    "bo": 1
  }, {
    "p": [335, 81, -62],
    "s": [60, 58, 60]
  }, {
    "p": [348, 0, -227],
    "s": [8, 44, 52],
    "bo": 1
  }, {
    "p": [393, 0, -420],
    "s": [88, 64, 197]
  }, {
    "p": [396, 0, -196],
    "s": [58, 81, 186]
  }, {
    "p": [-356, 0, -369],
    "s": [42, 98, 50]
  }, {
    "p": [-264, 0, -84],
    "s": [42, 124, 50],
    "c": 11316396
  }, {
    "p": [1, 0, 0],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-42, 0, -79],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-42, 12, -79],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-42, 0, -67],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [0, -28, -325],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [0, -28, -337],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [0, -16, -333],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-76, -28, -327],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-76, -16, -327],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [237, 10, -473],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [224, 10, -520],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [155, 10, -504],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [167, 10, -504],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [163, 22, -504],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [214, 10, -466],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [312, 0, -399],
    "s": [2, 2, 92]
  }, {
    "p": [318, 0, -242],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [227, 0, -281],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [215, 0, -281],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [224, 12, -281],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-59, 18, 19],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-110, 18, -36],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-110, 0, -52],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-122, 0, -52],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-165, 18, -39],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-215, 18, 13],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-154, 0, -252],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-313, 0, -235],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-133, 0, -469],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-190, 0, -485],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [206, 0, -207],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [206, 0, -195],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [98, 0, -61],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [98, 0, -73],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [95, 0, -52],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [133, 0, -150],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [192, 34, -188],
    "s": [40, 24, 82],
    "bo": 1
  }, {
    "p": [128, -4, -415],
    "s": [68, 12, 20],
    "t": 1
  }, {
    "p": [93, -28, -422],
    "s": [4, 42, 10]
  }, {
    "p": [337, -4, -150],
    "s": [22, 4, 94],
    "t": 1
  }, {
    "p": [-11, -28, -384],
    "s": [20, 34, 2],
    "pe": 1,
    "t": 2,
    "bo": 1
  }, {
    "p": [-32, -28, -370],
    "s": [18, 34, 2],
    "pe": 1,
    "t": 2,
    "bo": 1
  }, {
    "p": [173, 0, -233],
    "s": [2, 34, 24],
    "pe": 1,
    "t": 2
  }, {
    "p": [202, 0, -226],
    "s": [20, 34, 2],
    "pe": 1,
    "t": 2,
    "bo": 1
  }, {
    "p": [182, 0, -150],
    "s": [20, 34, 2],
    "pe": 1,
    "t": 2,
    "bo": 1
  }, {
    "p": [211, 0, -162],
    "s": [2, 34, 24],
    "t": 2,
    "bo": 1
  }, {
    "p": [20, -28, -438],
    "s": [28, 76, 40],
    "bo": 1
  }, {
    "p": [114, 0, -388],
    "s": [36, 8, 34],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [-337, 139, -563],
    "s": [12, 4, 6],
    "l": 1,
    "c": 11184810
  }, {
    "p": [-299, 139, -566],
    "s": [8, 4, 12],
    "l": 1,
    "c": 11644847
  }, {
    "p": [-297, 139, -586],
    "s": [4, 4, 12],
    "l": 1,
    "c": 11842740
  }, {
    "p": [-300, 139, -608],
    "s": [10, 4, 12],
    "l": 1,
    "c": 10855845
  }, {
    "p": [-316, 139, -563],
    "s": [12, 2, 6],
    "l": 1,
    "c": 11184810
  }, {
    "p": [-206, 86, -535],
    "s": [14, 4, 16],
    "l": 1
  }, {
    "p": [-126, 86, -535],
    "s": [22, 4, 16],
    "l": 1
  }, {
    "p": [-165, 86, -530],
    "s": [22, 4, 6],
    "l": 1
  }, {
    "p": [-209, 86, -560],
    "s": [8, 4, 14],
    "l": 1
  }, {
    "p": [-230, 52, -550],
    "s": [24, 2, 6],
    "l": 1
  }, {
    "p": [-264, 52, -550],
    "s": [18, 2, 6],
    "l": 1
  }, {
    "p": [-295, 52, -550],
    "s": [14, 4, 6],
    "l": 1
  }, {
    "p": [-316, 70, -502],
    "s": [6, 12, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [-378, 73, -502],
    "s": [6, 8, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [-318, 72, -504],
    "s": [14, 4, 14],
    "l": 1
  }, {
    "p": [-378, 72, -504],
    "s": [10, 2, 14],
    "l": 1
  }, {
    "p": [-358, 72, -499],
    "s": [14, 2, 4],
    "l": 1
  }, {
    "p": [-314, 72, -536],
    "s": [6, 4, 16],
    "l": 1
  }, {
    "p": [-321, 58, -480],
    "s": [4, 2, 24],
    "l": 1
  }, {
    "p": [-321, 58, -384],
    "s": [4, 4, 16],
    "l": 1
  }, {
    "p": [-321, 58, -413],
    "s": [4, 3, 21],
    "l": 1
  }, {
    "p": [-321, 58, -446],
    "s": [4, 3, 19],
    "l": 1
  }, {
    "p": [-53, 60, -392],
    "s": [20, 6, 12],
    "l": 1
  }, {
    "p": [-166, 60, -364],
    "s": [14, 4, 16],
    "l": 1
  }, {
    "p": [233, 45, -548],
    "s": [12, 2, 6],
    "l": 1
  }, {
    "p": [262, 45, -548],
    "s": [11, 2, 6],
    "l": 1,
    "c": 13290186
  }, {
    "p": [288, 45, -548],
    "s": [16, 2, 6],
    "l": 1
  }, {
    "p": [-82, 90, -466],
    "s": [14, 4, 12],
    "l": 1
  }, {
    "p": [-43, 90, -467],
    "s": [12, 4, 14],
    "l": 1
  }, {
    "p": [-44, 90, -519],
    "s": [14, 6, 30],
    "l": 1
  }, {
    "p": [-60, 90, -463],
    "s": [14, 2, 6],
    "l": 1
  }, {
    "p": [-39, 90, -490],
    "s": [4, 2, 16],
    "l": 1
  }, {
    "p": [-84, 90, -524],
    "s": [10, 3, 26],
    "l": 1
  }, {
    "p": [-87, 90, -492],
    "s": [4, 2, 10],
    "l": 1
  }, {
    "p": [-63, 71, -450],
    "s": [4, 4, 20],
    "t": 2,
    "bo": 1
  }, {
    "p": [-122, 55, -459],
    "s": [6, 16, 6],
    "t": 2
  }, {
    "p": [-124, 62, -507],
    "s": [6, 3, 16],
    "l": 1,
    "c": 14474460
  }, {
    "p": [-124, 62, -476],
    "s": [6, 2, 14],
    "l": 1,
    "c": 14935011
  }, {
    "p": [-88, 62, -457],
    "s": [18, 3, 6],
    "l": 1
  }, {
    "p": [-116, 60, -396],
    "s": [26, 4, 4],
    "l": 1
  }, {
    "p": [-164, 60, -392],
    "s": [18, 6, 12],
    "l": 1
  }, {
    "p": [-82, 60, -396],
    "s": [14, 3, 4],
    "l": 1
  }, {
    "p": [85, 66, -447],
    "s": [4, 4, 16],
    "t": 2,
    "bo": 1
  }, {
    "p": [-31, 44, -377],
    "s": [9, 4, 20],
    "bo": 1
  }, {
    "p": [-14, 44, -377],
    "s": [10, 2, 20],
    "bo": 1
  }, {
    "p": [-341, 98, -387],
    "s": [12, 4, 14],
    "l": 1
  }, {
    "p": [-341, 98, -350],
    "s": [12, 6, 12],
    "l": 1
  }, {
    "p": [-338, 98, -369],
    "s": [6, 2, 12],
    "l": 1
  }, {
    "p": [-371, 98, -389],
    "s": [12, 4, 10],
    "l": 1
  }, {
    "p": [-356, 98, -392],
    "s": [8, 2, 4],
    "l": 1
  }, {
    "p": [53, 65, -523],
    "s": [18, 4, 4],
    "l": 1
  }, {
    "p": [135, 65, -523],
    "s": [12, 4, 4],
    "l": 1
  }, {
    "p": [114, 65, -523],
    "s": [12, 4, 4],
    "l": 1
  }, {
    "p": [211, 97, -517],
    "s": [14, 6, 14],
    "l": 1
  }, {
    "p": [153, 97, -518],
    "s": [14, 4, 16],
    "l": 1
  }, {
    "p": [184, 97, -514],
    "s": [12, 2, 8],
    "l": 1
  }, {
    "p": [215, 97, -539],
    "s": [6, 2, 18],
    "l": 1
  }, {
    "p": [211, 97, -564],
    "s": [14, 6, 12],
    "l": 1
  }, {
    "p": [153, 97, -562],
    "s": [14, 6, 16],
    "l": 1
  }, {
    "p": [149, 97, -539],
    "s": [6, 2, 12],
    "l": 1
  }, {
    "p": [148, 16, -461],
    "s": [14, 1, 4]
  }, {
    "p": [242, 16, -461],
    "s": [18, 2, 4]
  }, {
    "p": [249, 16, -497],
    "s": [4, 2, 10]
  }, {
    "p": [96, 84, -459],
    "s": [6, 12, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [74, 84, -459],
    "s": [6, 10, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [97, 84, -537],
    "s": [6, 20, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [94, 84, -463],
    "s": [14, 4, 18],
    "l": 1
  }, {
    "p": [74, 84, -463],
    "s": [10, 4, 18],
    "l": 1
  }, {
    "p": [76, 84, -533],
    "s": [14, 4, 18],
    "l": 1
  }, {
    "p": [96, 84, -533],
    "s": [10, 4, 18],
    "l": 1
  }, {
    "p": [98, 84, -498],
    "s": [6, 4, 20],
    "l": 1
  }, {
    "p": [72, 84, -498],
    "s": [6, 4, 26],
    "l": 1
  }, {
    "p": [91, 76, -414],
    "s": [6, 16, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [85, 76, -410],
    "s": [24, 6, 18],
    "l": 1
  }, {
    "p": [13, 76, -410],
    "s": [24, 6, 18],
    "l": 1
  }, {
    "p": [48, 76, -416],
    "s": [20, 4, 6],
    "l": 1
  }, {
    "p": [12, 76, -358],
    "s": [22, 6, 14],
    "l": 1
  }, {
    "p": [5, 76, -382],
    "s": [8, 4, 14],
    "l": 1
  }, {
    "p": [53, 76, -354],
    "s": [22, 4, 6],
    "l": 1
  }, {
    "p": [85, 76, -360],
    "s": [24, 6, 18],
    "l": 1
  }, {
    "p": [93, 76, -387],
    "s": [8, 4, 14],
    "l": 1
  }, {
    "p": [6, 76, -414],
    "s": [6, 20, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [6, 76, -356],
    "s": [6, 14, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [334, 32, -432],
    "s": [4, 2, 18],
    "l": 1
  }, {
    "p": [334, 32, -376],
    "s": [4, 3, 18],
    "l": 1
  }, {
    "p": [334, 32, -406],
    "s": [4, 2, 22],
    "l": 1
  }, {
    "p": [147, 58, -402],
    "s": [31, 9, 6],
    "l": 1
  }, {
    "p": [136, 58, -378],
    "s": [9, 12, 42],
    "l": 1
  }, {
    "p": [198, 58, -418],
    "s": [10, 4, 6],
    "l": 1
  }, {
    "p": [245, 58, -375],
    "s": [7, 4, 20],
    "l": 1
  }, {
    "p": [234, 58, -413],
    "s": [29, 5, 16],
    "l": 1
  }, {
    "p": [236, 58, -299],
    "s": [25, 4, 24],
    "l": 1
  }, {
    "p": [245, 58, -341],
    "s": [7, 4, 20],
    "l": 1
  }, {
    "p": [243, 58, -416],
    "s": [6, 19, 6],
    "t": 2
  }, {
    "p": [314, 61, -349],
    "s": [10, 4, 18],
    "l": 1
  }, {
    "p": [333, 61, -356],
    "s": [11, 3, 4],
    "l": 1
  }, {
    "p": [354, 61, -349],
    "s": [18, 4, 18],
    "l": 1
  }, {
    "p": [312, 61, -306],
    "s": [6, 4, 28],
    "l": 1
  }, {
    "p": [316, 61, -259],
    "s": [14, 4, 22],
    "l": 1
  }, {
    "p": [334, 61, -250],
    "s": [11, 3, 4],
    "l": 1
  }, {
    "p": [356, 61, -257],
    "s": [14, 3, 18],
    "l": 1
  }, {
    "p": [285, 58, -88],
    "s": [2, 40, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [285, 58, -40],
    "s": [2, 40, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [294, 93, -64],
    "s": [22, 2, 53],
    "t": 2
  }, {
    "p": [193, 58, -290],
    "s": [24, 4, 6],
    "l": 1
  }, {
    "p": [136, 58, -332],
    "s": [9, 6, 24],
    "l": 1
  }, {
    "p": [348, 44, -236],
    "s": [8, 4, 16],
    "l": 1,
    "c": 15132390
  }, {
    "p": [348, 44, -216],
    "s": [8, 2, 8],
    "l": 1
  }, {
    "p": [352, 64, -379],
    "s": [6, 4, 20],
    "l": 1
  }, {
    "p": [352, 64, -415],
    "s": [6, 3, 14],
    "l": 1
  }, {
    "p": [310, 55, -490],
    "s": [4, 4, 14],
    "l": 1
  }, {
    "p": [315, 55, -451],
    "s": [14, 4, 14],
    "l": 1
  }, {
    "p": [310, 55, -473],
    "s": [4, 2, 10],
    "l": 1
  }, {
    "p": [342, 55, -446],
    "s": [14, 4, 4],
    "l": 1
  }, {
    "p": [307, 112, -576],
    "s": [6, 4, 22],
    "l": 1,
    "c": "#b1b1b1"
  }, {
    "p": [335, 139, -89],
    "s": [12, 4, 6],
    "l": 1
  }, {
    "p": [313, 139, -84],
    "s": [16, 6, 16],
    "l": 1
  }, {
    "p": [357, 139, -84],
    "s": [16, 6, 16],
    "l": 1
  }, {
    "p": [313, 139, -40],
    "s": [16, 6, 16],
    "l": 1
  }, {
    "p": [308, 139, -62],
    "s": [6, 4, 12],
    "l": 1
  }, {
    "p": [228, 48, -102],
    "s": [10, 2, 14],
    "l": 1
  }, {
    "p": [-293, 40, -321],
    "s": [32, 22, 88],
    "bo": 1
  }, {
    "p": [-192, 62, -323],
    "s": [20, 4, 66],
    "l": 1
  }, {
    "p": [-328, 62, -361],
    "s": [20, 4, 8],
    "l": 1
  }, {
    "p": [-296, 62, -361],
    "s": [20, 4, 8],
    "l": 1
  }, {
    "p": [-253, 73, -364],
    "s": [6, 10, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [-274, 73, -364],
    "s": [6, 14, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [-274, 74, -322],
    "s": [8, 4, 94],
    "l": 1
  }, {
    "p": [-252, 74, -283],
    "s": [8, 4, 16],
    "l": 1
  }, {
    "p": [9, 6, -313],
    "s": [6, 2, 18]
  }, {
    "p": [9, 6, -199],
    "s": [6, 2, 18]
  }, {
    "p": [9, 6, -252],
    "s": [6, 2, 10]
  }, {
    "p": [164, 0, -61],
    "s": [4, 62, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [154, 54, -61],
    "s": [16, 4, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [158, 51, -61],
    "s": [16, 2, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "t": 2
  }, {
    "p": [-263, 0, -273],
    "s": [4, 54, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [-263, 47, -263],
    "s": [4, 4, 16],
    "t": 2,
    "bo": 1
  }, {
    "p": [-263, 43, -268],
    "s": [2, 2, 16],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [238, 86, -224],
    "s": [12, 4, 10],
    "l": 1
  }, {
    "p": [240, 86, -152],
    "s": [8, 4, 10],
    "l": 1
  }, {
    "p": [217, 86, -222],
    "s": [10, 4, 14],
    "l": 1
  }, {
    "p": [242, 86, -189],
    "s": [4, 4, 28],
    "l": 1
  }, {
    "p": [251, 92, -82],
    "s": [18, 6, 18],
    "l": 1,
    "c": 11184810
  }, {
    "p": [176, 92, -84],
    "s": [20, 4, 14],
    "l": 1,
    "c": 11645361
  }, {
    "p": [173, 92, -38],
    "s": [14, 4, 14],
    "l": 1,
    "c": 12303291
  }, {
    "p": [207, 92, -88],
    "s": [20, 4, 6],
    "l": 1,
    "c": 12171705
  }, {
    "p": [168, 92, -61],
    "s": [4, 2, 12],
    "l": 1,
    "c": 10987431
  }, {
    "p": [254, 92, -41],
    "s": [12, 4, 20],
    "l": 1,
    "c": 11974326
  }, {
    "p": [214, 92, -34],
    "s": [24, 4, 6],
    "l": 1,
    "c": 11513775
  }, {
    "p": [145, 70, -158],
    "s": [10, 4, 22],
    "l": 1
  }, {
    "p": [168, 70, -154],
    "s": [8, 4, 14],
    "l": 1
  }, {
    "p": [145, 70, -218],
    "s": [10, 4, 22],
    "l": 1
  }, {
    "p": [168, 70, -222],
    "s": [8, 4, 14],
    "l": 1
  }, {
    "p": [214, 86, -184],
    "s": [4, 2, 24],
    "l": 1
  }, {
    "p": [216, 86, -152],
    "s": [8, 4, 10],
    "l": 1
  }, {
    "p": [179, 67, 0],
    "s": [4, 2, 10],
    "l": 1
  }, {
    "p": [179, 67, 17],
    "s": [4, 6, 15],
    "l": 1
  }, {
    "p": [136, 44, -157],
    "s": [4, 38, 4],
    "t": 2
  }, {
    "p": [45, 44, -157],
    "s": [4, 38, 4],
    "t": 2
  }, {
    "p": [45, 44, -193],
    "s": [4, 38, 4],
    "t": 2
  }, {
    "p": [136, 44, -193],
    "s": [4, 42, 4],
    "t": 2
  }, {
    "p": [91, 58, -175],
    "s": [100, 2, 44],
    "t": 2,
    "bo": 1
  }, {
    "p": [127, 44, -155],
    "s": [26, 4, 4],
    "l": 1
  }, {
    "p": [48, 44, -159],
    "s": [14, 4, 12],
    "l": 1
  }, {
    "p": [46, 44, -191],
    "s": [10, 4, 12],
    "l": 1
  }, {
    "p": [90, 44, -155],
    "s": [18, 2, 4],
    "l": 1
  }, {
    "p": [195, 58, -226],
    "s": [18, 4, 6],
    "l": 1
  }, {
    "p": [186, 58, -150],
    "s": [18, 4, 6],
    "l": 1
  }, {
    "p": [-3, 54, -100],
    "s": [30, 6, 16],
    "l": 1
  }, {
    "p": [77, 54, -98],
    "s": [30, 6, 20],
    "l": 1
  }, {
    "p": [79, 54, -35],
    "s": [26, 6, 14],
    "l": 1
  }, {
    "p": [-5, 54, -35],
    "s": [26, 6, 14],
    "l": 1
  }, {
    "p": [89, 54, -66],
    "s": [6, 4, 20],
    "l": 1
  }, {
    "p": [37, 54, -105],
    "s": [30, 4, 6],
    "l": 1
  }, {
    "p": [-15, 54, -66],
    "s": [6, 4, 20],
    "l": 1
  }, {
    "p": [38, 54, -31],
    "s": [18, 4, 6],
    "l": 1
  }, {
    "p": [-53, 60, -364],
    "s": [20, 4, 16],
    "l": 1
  }, {
    "p": [-237, 50, 35],
    "s": [5, 2, 10],
    "l": 1,
    "c": 13158600
  }, {
    "p": [164, 92, 31],
    "s": [28, 6, 16],
    "l": 1,
    "c": 11842740
  }, {
    "p": [205, 92, 31],
    "s": [10, 4, 16],
    "l": 1,
    "c": 13816530
  }, {
    "p": [156, 92, 60],
    "s": [12, 6, 14],
    "l": 1,
    "c": 13158600
  }, {
    "p": [-260, 47, 19],
    "s": [4, 54, 158]
  }, {
    "p": [-197, 47, 97],
    "s": [158, 54, 4]
  }, {
    "p": [-178, 13, 51],
    "s": [4, 74, 4],
    "t": 2
  }, {
    "p": [-254, 13, 51],
    "s": [4, 74, 4],
    "t": 2
  }, {
    "p": [-216, 80, 72],
    "s": [84, 2, 50],
    "t": 2
  }, {
    "p": [-55, 74, 2],
    "s": [14, 6, 22],
    "l": 1
  }, {
    "p": [-97, 74, 1],
    "s": [14, 6, 24],
    "l": 1
  }, {
    "p": [-102, 74, -42],
    "s": [4, 4, 24],
    "l": 1
  }, {
    "p": [-102, 74, -75],
    "s": [4, 4, 14],
    "l": 1
  }, {
    "p": [-77, 74, 11],
    "s": [14, 4, 4],
    "l": 1
  }, {
    "p": [-50, 74, -45],
    "s": [4, 4, 24],
    "l": 1
  }, {
    "p": [-54, 74, -97],
    "s": [12, 4, 24],
    "l": 1
  }, {
    "p": [-236, 50, -131],
    "s": [7, 4, 24],
    "l": 1,
    "c": 13158086
  }, {
    "p": [-236, 50, -96],
    "s": [7, 4, 22],
    "l": 1,
    "c": 11974326
  }, {
    "p": [-221, 60, 14],
    "s": [6, 2, 15],
    "l": 1
  }, {
    "p": [-244, 60, 13],
    "s": [12, 2, 17],
    "l": 1
  }, {
    "p": [-224, 60, -61],
    "s": [12, 2, 29],
    "l": 1
  }, {
    "p": [-220, 60, -17],
    "s": [4, 2, 8],
    "l": 1
  }, {
    "p": [-251, 124, -64],
    "s": [16, 4, 10],
    "l": 1,
    "c": 12171191
  }, {
    "p": [-279, 124, -66],
    "s": [12, 4, 14],
    "l": 1,
    "c": 12829635
  }, {
    "p": [-278, 124, -105],
    "s": [14, 3, 8],
    "l": 1
  }, {
    "p": [-109, 60, -359],
    "s": [34, 4, 6],
    "l": 1
  }, {
    "p": [-130, 77, -156],
    "s": [14, 3, 6],
    "l": 1
  }, {
    "p": [357, 139, -40],
    "s": [16, 6, 16],
    "l": 1
  }, {
    "p": [-296, 62, -281],
    "s": [20, 4, 8],
    "l": 1
  }, {
    "p": [-323, 62, -281],
    "s": [14, 4, 8],
    "l": 1
  }, {
    "p": [9, 0, -180],
    "s": [4, 54, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [9, 44, -175],
    "s": [2, 2, 12],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [-106, 84, -96],
    "s": [14, 6, 24],
    "l": 1
  }, {
    "p": [-110, 84, -137],
    "s": [6, 4, 24],
    "l": 1
  }, {
    "p": [-64, 84, -96],
    "s": [14, 6, 24],
    "l": 1
  }, {
    "p": [-64, 84, -184],
    "s": [14, 6, 24],
    "l": 1
  }, {
    "p": [-60, 84, -137],
    "s": [6, 4, 16],
    "l": 1
  }, {
    "p": [-182, 51, 55],
    "s": [16, 4, 16],
    "l": 1
  }, {
    "p": [-250, 51, 50],
    "s": [16, 4, 6],
    "l": 1
  }, {
    "p": [-212, 51, 50],
    "s": [16, 2, 6],
    "l": 1
  }, {
    "p": [-252, 51, 60],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [343, 32, -364],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [243, 56, -292],
    "s": [6, 28, 6],
    "t": 2
  }, {
    "p": [10, 24, 8],
    "s": [18, 2, 4]
  }, {
    "p": [82, 24, 8],
    "s": [20, 2, 4]
  }, {
    "p": [-35, 24, 8],
    "s": [9, 1, 4]
  }, {
    "p": [-129, 24, -44],
    "s": [16, 2, 4]
  }, {
    "p": [-164, 24, -44],
    "s": [16, 2, 4]
  }, {
    "p": [-170, 24, -31],
    "s": [4, 2, 22]
  }, {
    "p": [-170, 24, 4],
    "s": [4, 2, 12]
  }, {
    "p": [-227, 62, -323],
    "s": [20, 4, 66],
    "l": 1
  }, {
    "p": [-108, 83, -89],
    "s": [6, 26, 6],
    "t": 2
  }, {
    "p": [-250, 44, -124],
    "s": [4, 41, 4],
    "t": 2
  }, {
    "p": [-280, 44, -124],
    "s": [4, 40, 4],
    "t": 2
  }, {
    "p": [-265, 74, -117],
    "s": [38, 2, 22],
    "t": 2
  }, {
    "p": [-57, 66, -201],
    "s": [10, 6, 36],
    "l": 1
  }, {
    "p": [-57, 66, -260],
    "s": [10, 4, 26],
    "l": 1
  }, {
    "p": [-61, 66, -308],
    "s": [18, 4, 26],
    "l": 1
  }, {
    "p": [-103, 66, -308],
    "s": [18, 4, 26],
    "l": 1
  }, {
    "p": [-107, 66, -251],
    "s": [10, 4, 22],
    "l": 1
  }, {
    "p": [-168, 62, -268],
    "s": [8, 2, 20],
    "l": 1
  }, {
    "p": [-150, 62, -268],
    "s": [12, 4, 20],
    "l": 1
  }, {
    "p": [-148, 62, -304],
    "s": [8, 4, 20],
    "l": 1
  }, {
    "p": [-148, 62, -342],
    "s": [8, 4, 28],
    "l": 1
  }, {
    "p": [335, 100, -92],
    "s": [6, 20, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [196, 51, -91],
    "s": [6, 20, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [-243, 94, -84],
    "s": [2, 16, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-295, 112, -587],
    "s": [2, 14, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-319, 112, -560],
    "s": [5, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [305, 100, -62],
    "s": [2, 20, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [304, 78, -518],
    "s": [2, 14, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [203, 70, -510],
    "s": [5, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [183, 70, -510],
    "s": [5, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [162, 70, -510],
    "s": [5, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [38, 18, 52],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [300, 49, -301],
    "s": [18, 4, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [-210, 0, -155],
    "s": [4, 1, 6],
    "l": 1
  }, {
    "p": [-177, 0, -258],
    "s": [4, 2, 6],
    "l": 1
  }, {
    "p": [-271, 0, -270],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [-242, 0, -431],
    "s": [8, 2, 4],
    "l": 1
  }, {
    "p": [-174, 0, -403],
    "s": [4, 1, 4],
    "l": 1
  }, {
    "p": [-154, -1, -404],
    "s": [8, 2, 8],
    "l": 1
  }, {
    "p": [-5, -28, -393],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [307, 0, -439],
    "s": [4, 1, 6],
    "l": 1
  }, {
    "p": [338, 0, -212],
    "s": [4, 2, 8],
    "l": 1
  }, {
    "p": [305, 0, -254],
    "s": [4, 2, 6],
    "l": 1
  }, {
    "p": [223, 0, -232],
    "s": [8, 2, 4],
    "l": 1
  }, {
    "p": [203, 0, -284],
    "s": [8, 2, 4],
    "c": 11316396
  }, {
    "p": [101, 0, -355],
    "s": [4, 2, 8],
    "l": 1
  }, {
    "p": [15, 0, -345],
    "s": [4, 2, 8],
    "l": 1
  }, {
    "p": [15, 0, -211],
    "s": [4, 2, 8]
  }, {
    "p": [-50, 0, -175],
    "s": [6, 2, 8],
    "l": 1
  }, {
    "p": [97, 0, -87],
    "s": [6, 2, 8],
    "l": 1
  }, {
    "p": [94, 0, 0],
    "s": [10, 2, 4],
    "l": 1
  }, {
    "p": [-43, 0, -1],
    "s": [6, 2, 8],
    "l": 1
  }, {
    "p": [-11, 18, 15],
    "s": [10, 2, 4],
    "l": 1
  }, {
    "p": [-154, 18, -38],
    "s": [6, 1, 3],
    "l": 1
  }, {
    "p": [-108, 18, -7],
    "s": [4, 2, 10],
    "l": 1
  }, {
    "p": [-136, 0, -52],
    "s": [8, 2, 6],
    "l": 1
  }, {
    "p": [162, 0, -52],
    "s": [3, 2, 5],
    "l": 1
  }, {
    "p": [46, 0, -149],
    "s": [6, 1, 5],
    "l": 1
  }, {
    "p": [-306, 0, -349],
    "s": [4, 1, 7],
    "l": 1
  }, {
    "p": [-332, 0, -270],
    "s": [4, 2, 8],
    "l": 1
  }, {
    "p": [-59, -28, -325],
    "s": [4, 2, 4]
  }, {
    "p": [-141, -28, -351],
    "s": [4, 2, 8]
  }, {
    "p": [-182, 0, -218],
    "s": [4, 2, 8],
    "l": 1
  }, {
    "p": [-218, 18, 43],
    "s": [8, 1, 4],
    "l": 1
  }, {
    "p": [-40, 18, 52],
    "s": [6, 2, 8],
    "l": 1
  }, {
    "p": [119, 0, -149],
    "s": [6, 2, 6],
    "l": 1
  }, {
    "p": [-196, 0, -524],
    "s": [5, 1, 4],
    "l": 1
  }, {
    "p": [160, 0, -70],
    "s": [4, 2, 4],
    "l": 1
  }, {
    "p": [-52, 0, -163],
    "s": [4, 2, 4],
    "l": 1
  }, {
    "p": [251, 0, -407],
    "s": [4, 2, 6],
    "l": 1
  }, {
    "p": [-5, -28, -408],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [251, 0, -288],
    "s": [3, 1, 5],
    "l": 1,
    "c": 12829635
  }, {
    "p": [313, 0, -344],
    "s": [3, 1, 4]
  }, {
    "p": [321, 0, -364],
    "s": [4, 2, 4],
    "l": 1
  }, {
    "p": [202, 0, -94],
    "s": [4, 1, 4]
  }, {
    "p": [16, 0, -264],
    "s": [4, 1, 6]
  }, {
    "p": [37, 0, -307],
    "s": [4, 6, 38]
  }, {
    "p": [94, 0, -325],
    "s": [22, 6, 4]
  }, {
    "p": [107, 0, -314],
    "s": [4, 6, 26]
  }, {
    "p": [37, 6, -316],
    "s": [4, 2, 10]
  }, {
    "p": [107, 6, -321],
    "s": [4, 2, 12]
  }, {
    "p": [99, 6, -325],
    "s": [12, 4, 4]
  }, {
    "p": [76, 0, -325],
    "s": [14, 2, 4]
  }, {
    "p": [9, 47, -171],
    "s": [4, 4, 14],
    "t": 2,
    "bo": 1
  }, {
    "p": [85, -1, -226],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [65, -1, -200],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [-124, 61, -114],
    "s": [22, 4, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [22, 45, -351],
    "s": [6, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [51, 45, -351],
    "s": [6, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [79, 45, -351],
    "s": [6, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [-63, 68, -456],
    "s": [2, 2, 14],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [-115, 57, -114],
    "s": [14, 2, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "t": 2
  }, {
    "p": [91, 77, -175],
    "s": [100, 2, 44],
    "t": 2,
    "bo": 1
  }, {
    "p": [107, 10, -469],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [203, -28, -413],
    "s": [91, 86, 16],
    "bo": 1
  }, {
    "p": [165, 58, -413],
    "s": [11, 6, 16],
    "l": 1
  }, {
    "p": [179, 16, -461],
    "s": [20, 2, 4]
  }, {
    "p": [344, 50, -196],
    "s": [12, 3, 18],
    "l": 1,
    "c": "#b1b1b1"
  }, {
    "p": [340, 50, -160],
    "s": [4, 2, 18],
    "l": 1,
    "c": "#b9b9b9"
  }, {
    "p": [340, 50, -123],
    "s": [4, 4, 22],
    "l": 1,
    "c": "#b9b9b9"
  }, {
    "p": [322, -1, -401],
    "s": [20, 2, 96],
    "c": 10987431,
    "t": 1
  }, {
    "p": [144, 58, -294],
    "s": [25, 4, 14],
    "l": 1
  }, {
    "p": [305, 45, -301],
    "s": [14, 2, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "t": 2
  }, {
    "p": [85, 62, -453],
    "s": [2, 2, 14],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [-22, 65, -523],
    "s": [18, 4, 4],
    "l": 1
  }, {
    "p": [16, 65, -523],
    "s": [20, 2, 4],
    "l": 1
  }, {
    "p": [-146, 0, -475],
    "s": [8, 26, 2],
    "i": 3,
    "t": 2,
    "d": 1
  }, {
    "p": [-210, 0, -276],
    "s": [76, 5, 2],
    "c": 13158600
  }, {
    "p": [-210, 0, -284],
    "s": [76, 4, 14],
    "l": 1,
    "c": 1916250,
    "o": 0.8,
    "t": 5
  }, {
    "p": [-253, 0, -269],
    "s": [4, 2, 6],
    "l": 1
  }, {
    "p": [-175, 0, -270],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-302, 0, -232],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-128, 0, -115],
    "s": [6, 2, 66],
    "t": 2
  }, {
    "p": [-121, 0, -114],
    "s": [6, 2, 66],
    "c": 13290186,
    "t": 2
  }, {
    "p": [-132, 2, -113],
    "s": [6, 2, 66],
    "t": 2
  }, {
    "p": [-125, 2, -114],
    "s": [6, 2, 66],
    "t": 2
  }, {
    "p": [-128, 4, -112],
    "s": [6, 2, 66],
    "c": 12632256,
    "t": 2
  }, {
    "p": [-135, 0, -112],
    "s": [6, 2, 66],
    "c": 12303291,
    "t": 2
  }, {
    "p": [-132, 38, -114],
    "s": [1, 25, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [-196, 46, -191],
    "s": [34, 31, 76],
    "bo": 1
  }, {
    "p": [-183, 40, -157],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-192, 42, -157],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-201, 41, -157],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-209, 40, -157],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-192, 41, -227],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-183, 40, -227],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-201, 42, -227],
    "s": [2, 4, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-209, 40, -227],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-442, 0, 157],
    "s": [62, 206, 72],
    "l": 1
  }, {
    "p": [-418, 206, 129],
    "s": [14, 6, 16],
    "l": 1
  }, {
    "p": [-414, 206, 157],
    "s": [6, 6, 22],
    "l": 1
  }, {
    "p": [-414, 206, 186],
    "s": [6, 4, 14],
    "l": 1
  }, {
    "p": [-444, 206, 123],
    "s": [20, 6, 4],
    "l": 1
  }, {
    "p": [-468, 206, 123],
    "s": [10, 6, 4],
    "l": 1
  }, {
    "p": [-442, 163, 121],
    "s": [8, 20, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [-178, 13, 93],
    "s": [4, 74, 4],
    "t": 2
  }, {
    "p": [-254, 13, 93],
    "s": [4, 74, 4],
    "t": 2
  }, {
    "p": [-19, 64, 74],
    "s": [60, 12, 38],
    "bo": 1
  }, {
    "p": [123, 76, 57],
    "s": [28, 4, 4],
    "l": 1
  }, {
    "p": [70, 76, 57],
    "s": [34, 2, 4],
    "l": 1
  }, {
    "p": [21, 76, 57],
    "s": [26, 4, 4],
    "l": 1
  }, {
    "p": [-41, 76, 57],
    "s": [12, 2, 4],
    "l": 1
  }, {
    "p": [-75, 76, 57],
    "s": [16, 2, 4],
    "l": 1
  }, {
    "p": [-127, 76, 57],
    "s": [26, 4, 4],
    "l": 1
  }, {
    "p": [-19, 0, 73],
    "s": [60, 64, 2],
    "t": 2,
    "bo": 1
  }, {
    "p": [-46, 18, 61],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-13, 32, 71],
    "s": [4, 4, 2],
    "l": 1,
    "c": 3092271,
    "t": 5,
    "bo": 1
  }, {
    "p": [-26, 32, 71],
    "s": [4, 4, 2],
    "l": 1,
    "c": 3092271,
    "t": 5,
    "bo": 1
  }, {
    "p": [19, 63, 48],
    "s": [4, 4, 16],
    "t": 2,
    "bo": 1
  }, {
    "p": [-56, 63, 48],
    "s": [4, 4, 16],
    "t": 2,
    "bo": 1
  }, {
    "p": [-56, 59, 53],
    "s": [2, 2, 12],
    "l": 1,
    "r": [0.87, 0, 0],
    "t": 2
  }, {
    "p": [19, 59, 53],
    "s": [2, 2, 12],
    "l": 1,
    "r": [0.87, 0, 0],
    "t": 2
  }, {
    "p": [-139, 301, 405],
    "s": [110, 66, 86],
    "t": 5
  }, {
    "p": [-73, 281, 361],
    "s": [70, 42, 56],
    "t": 5
  }, {
    "p": [-527, 412, 373],
    "s": [146, 90, 116],
    "t": 5
  }, {
    "p": [-571, 369, 297],
    "s": [118, 72, 94],
    "t": 5
  }, {
    "p": [673, 319, 120],
    "s": [110, 66, 86],
    "t": 5
  }, {
    "p": [485, 337, 226],
    "s": [146, 88, 198],
    "t": 5
  }, {
    "p": [334, 337, 95],
    "s": [58, 30, 97],
    "l": 1,
    "t": 5
  }, {
    "p": [-866, 323, -277],
    "s": [146, 90, 196],
    "l": 1,
    "t": 5
  }, {
    "p": [-926, 303, -516],
    "s": [122, 76, 160],
    "l": 1,
    "t": 5
  }, {
    "p": [-1998, 360, -35],
    "s": [260, 76, 368],
    "l": 1,
    "t": 5
  }, {
    "p": [1593, 397, -140],
    "s": [218, 132, 256],
    "t": 5
  }, {
    "p": [1593, 377, -267],
    "s": [118, 72, 92],
    "t": 5
  }, {
    "p": [-130, 234, -914],
    "s": [146, 90, 116],
    "t": 5
  }, {
    "p": [-46, 204, -952],
    "s": [118, 74, 94],
    "t": 5
  }, {
    "p": [98, 204, -952],
    "s": [96, 38, 48],
    "l": 1,
    "t": 5
  }, {
    "p": [735, 363, -1249],
    "s": [224, 104, 178],
    "t": 5
  }, {
    "p": [186, 263, 500],
    "s": [104, 58, 112],
    "l": 1,
    "t": 5
  }, {
    "p": [81, 263, 500],
    "s": [48, 28, 52],
    "l": 1,
    "t": 5
  }, {
    "p": [-561, 204, -851],
    "s": [118, 74, 94],
    "t": 5
  }, {
    "p": [-22, -28, -518],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-34, -16, -518],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-31, -28, -515],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [60, -28, -425],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [63, -28, -515],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [63, -28, -503],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [54, -28, -518],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [218, 70, -541],
    "s": [2, 14, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-13, 76, 57],
    "s": [10, 4, 4],
    "l": 1
  }, {
    "p": [-19, 70, 102],
    "s": [220, 40, 58],
    "c": 12303291,
    "bo": 1
  }, {
    "p": [89, 110, 108],
    "s": [4, 4, 18],
    "l": 1,
    "c": 13814731
  }, {
    "p": [-119, 110, 80],
    "s": [20, 4, 14],
    "l": 1,
    "c": 12303291
  }, {
    "p": [36, 110, 75],
    "s": [16, 4, 4],
    "l": 1,
    "c": 12500156
  }, {
    "p": [-2, 110, 75],
    "s": [24, 2, 4],
    "l": 1,
    "c": 12631228
  }, {
    "p": [-78, 110, 75],
    "s": [14, 2, 4],
    "l": 1,
    "c": 10329501
  }, {
    "p": [-44, 110, 75],
    "s": [14, 4, 4],
    "l": 1,
    "c": 12961221
  }, {
    "p": [81, 110, 80],
    "s": [20, 4, 14],
    "l": 1,
    "c": 12303291
  }, {
    "p": [-127, 110, 108],
    "s": [4, 4, 18],
    "l": 1,
    "c": 11645361
  }, {
    "p": [-121, 99, 70],
    "s": [4, 4, 8],
    "t": 2
  }, {
    "p": [82, 99, 70],
    "s": [4, 4, 8],
    "t": 2
  }, {
    "p": [92, 99, 82],
    "s": [12, 4, 4],
    "t": 2
  }, {
    "p": [-131, 99, 82],
    "s": [10, 4, 4],
    "t": 2
  }, {
    "p": [292, 45, -113],
    "s": [60, 2, 20],
    "t": 2,
    "bo": 1
  }, {
    "p": [264, 0, -121],
    "s": [2, 49, 2],
    "t": 2
  }, {
    "p": [12, -28, -461],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [138, -28, -456],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [20, 48, -433],
    "s": [28, 4, 14],
    "l": 1
  }, {
    "p": [20, 48, -453],
    "s": [28, 2, 10],
    "l": 1
  }, {
    "p": [161, -28, -424],
    "s": [4, 42, 6]
  }, {
    "p": [-109, 40, -404],
    "s": [4, 4, 14],
    "t": 2,
    "bo": 1
  }, {
    "p": [-109, 37, -400],
    "s": [2, 2, 14],
    "l": 1,
    "r": [0.7, 0, 0],
    "t": 2
  }, {
    "p": [20, 34, -461],
    "s": [4, 4, 20],
    "t": 2,
    "bo": 1
  }, {
    "p": [20, 32, -461],
    "s": [2, 2, 12],
    "l": 1,
    "r": [0.87, 0, 0],
    "t": 2
  }, {
    "p": [21, -28, -464],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [21, -16, -464],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-253, 57, -559],
    "s": [74, 32, 2],
    "c": 6904648,
    "t": 5
  }, {
    "p": [-286, 52, -562],
    "s": [4, 40, 4],
    "t": 2
  }, {
    "p": [-221, 52, -562],
    "s": [4, 40, 4],
    "t": 2
  }, {
    "p": [260, 51, -568],
    "s": [74, 32, 2],
    "c": 7363405,
    "t": 5
  }, {
    "p": [260, 67, -566],
    "s": [69, 0, 29],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "sad": 1
  }, {
    "p": [-258, 69, -18],
    "s": [2, 26, 62],
    "c": 6903619,
    "t": 5
  }, {
    "p": [-256, 82, -18],
    "s": [57, 0, 23],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "sad": 1
  }, {
    "p": [72, 0, -277],
    "s": [64, 41, 90],
    "i": 14,
    "l": 1
  }, {
    "p": [-283, 10, -505],
    "s": [69, 41, 78],
    "i": 14,
    "l": 1
  }, {
    "p": [174, 10, -504],
    "s": [142, 41, 78],
    "i": 14,
    "l": 1
  }, {
    "p": [-136, 18, -16],
    "s": [59, 41, 49],
    "i": 14,
    "l": 1
  }, {
    "p": [336, 79, -303],
    "s": [54, 2, 110],
    "t": 2,
    "bo": 1
  }, {
    "p": [312, 60, -251],
    "s": [4, 25, 4],
    "t": 2
  }, {
    "p": [312, 62, -355],
    "s": [4, 25, 4],
    "t": 2
  }, {
    "p": [360, 61, -355],
    "s": [4, 24, 4],
    "t": 2
  }, {
    "p": [360, 61, -251],
    "s": [4, 26, 4],
    "t": 2
  }, {
    "p": [257, 47, -352],
    "s": [18, 4, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [252, 44, -352],
    "s": [14, 2, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "t": 2
  }, {
    "p": [213, 0, -97],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [210, 56, -292],
    "s": [6, 30, 6],
    "t": 2
  }, {
    "p": [243, 56, -326],
    "s": [6, 29, 6],
    "t": 2
  }, {
    "p": [210, 56, -326],
    "s": [6, 26, 6],
    "t": 2
  }, {
    "p": [227, 77, -309],
    "s": [42, 2, 43],
    "t": 2,
    "bo": 1
  }, {
    "p": [137, 56, -292],
    "s": [6, 22, 6],
    "t": 2
  }, {
    "p": [-11, -28, -514],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [277, 10, -540],
    "s": [8, 1, 4],
    "l": 1
  }, {
    "p": [2, -28, -448],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [-147, 62, -261],
    "s": [4, 12, 4],
    "t": 2
  }, {
    "p": [-169, 62, -261],
    "s": [4, 15, 4],
    "t": 2
  }, {
    "p": [-169, 62, -286],
    "s": [4, 11, 4],
    "t": 2
  }, {
    "p": [-147, 62, -287],
    "s": [4, 13, 4],
    "t": 2
  }, {
    "p": [-158, 70, -274],
    "s": [28, 1, 32],
    "t": 2,
    "bo": 1
  }, {
    "p": [-118, 61, -197],
    "s": [48, 87, 47],
    "c": 10987431
  }, {
    "p": [-119, 96, -197],
    "s": [85, 2, 46],
    "t": 2
  }, {
    "p": [-159, 72, -218],
    "s": [3, 30, 3],
    "t": 2
  }, {
    "p": [-143, 72, -218],
    "s": [3, 28, 3],
    "t": 2
  }, {
    "p": [-143, 72, -176],
    "s": [3, 29, 3],
    "t": 2
  }, {
    "p": [-159, 72, -176],
    "s": [3, 28, 3],
    "t": 2
  }, {
    "p": [263, 35, -352],
    "s": [1, 13, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [-109, 28, -409],
    "s": [1, 13, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [-174, 0, -472],
    "s": [6, 1, 4],
    "l": 1
  }, {
    "p": [-147, 18, 52],
    "s": [6, 1, 5],
    "l": 1
  }, {
    "p": [200, 220, -911],
    "s": [174, 74, 155],
    "t": 5
  }, {
    "p": [92, 76, -356],
    "s": [6, 17, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [-48, 59, -361],
    "s": [6, 14, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [228, 48, -137],
    "s": [10, 3, 11],
    "l": 1
  }, {
    "p": [37, 0, -160],
    "s": [8, 13, 4]
  }, {
    "p": [29, 0, -160],
    "s": [8, 6, 4]
  }, {
    "p": [7, 0, -173],
    "s": [4, 1, 4],
    "l": 1
  }, {
    "p": [-79, 66, -218],
    "s": [3, 33, 3],
    "t": 2
  }, {
    "p": [-79, 84, -177],
    "s": [3, 17, 3],
    "t": 2
  }, {
    "p": [-93, 84, -177],
    "s": [3, 17, 3],
    "t": 2
  }, {
    "p": [-93, 66, -218],
    "s": [3, 35, 3],
    "t": 2
  }, {
    "p": [-96, 148, -197],
    "s": [4, 3, 11],
    "l": 1,
    "c": 10987431
  }, {
    "p": [-140, 148, -202],
    "s": [4, 3, 15],
    "l": 1,
    "c": 9013641
  }, {
    "p": [-137, 148, -178],
    "s": [10, 3, 9],
    "l": 1,
    "c": 11513775
  }, {
    "p": [-99, 148, -178],
    "s": [10, 3, 9],
    "l": 1,
    "c": 11973298
  }, {
    "p": [-99, 148, -216],
    "s": [10, 4, 9],
    "l": 1,
    "c": 10987431
  }, {
    "p": [-117, 148, -218],
    "s": [12, 2, 5],
    "l": 1,
    "c": 11974326
  }, {
    "p": [-138, 148, -217],
    "s": [8, 3, 7],
    "l": 1,
    "c": 10197915
  }, {
    "p": [-120, 148, -176],
    "s": [9, 2, 5],
    "l": 1,
    "c": 11513775
  }, {
    "p": [-118, 117, -197],
    "s": [50, 16, 5],
    "l": 1,
    "c": 0
  }, {
    "p": [-118, 117, -197],
    "s": [5, 16, 49],
    "l": 1,
    "c": 0
  }, {
    "p": [-43, 43, -298],
    "s": [18, 4, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [-48, 39, -298],
    "s": [14, 2, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": 15132390,
    "t": 2
  }, {
    "p": [-37, 31, -298],
    "s": [1, 13, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [-212, 50, -63],
    "s": [14, 4, 4],
    "t": 2
  }, {
    "p": [-166, 0, -150],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [22, 42, -350],
    "s": [9, 3, 3],
    "c": 14935011,
    "bo": 1
  }, {
    "p": [51, 42, -350],
    "s": [9, 3, 3],
    "bo": 1
  }, {
    "p": [79, 42, -350],
    "s": [9, 3, 3],
    "bo": 1
  }, {
    "p": [183, 67, -509],
    "s": [9, 3, 3],
    "bo": 1
  }, {
    "p": [203, 67, -509],
    "s": [9, 3, 3],
    "bo": 1
  }, {
    "p": [162, 67, -509],
    "s": [9, 3, 3],
    "bo": 1
  }, {
    "p": [-54, 0, -115],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-54, 0, -121],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [8, 18, 69],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [306, 0, -321],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [251, 0, -352],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-160, 0, -150],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-154, 0, -150],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [71, 0, -345],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-119, 18, -39],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-73, 17, 16],
    "s": [5, 2, 4],
    "l": 1
  }, {
    "p": [-116, 0, -233],
    "s": [4, 2, 6],
    "l": 1
  }, {
    "p": [-169, 62, -393],
    "s": [6, 12, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [174, 0, -28],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [174, 0, -23],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [176, 0, -16],
    "s": [2, 19, 4],
    "t": 2
  }, {
    "p": [112, 0, -209],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [55, -1, -255],
    "s": [6, 3, 4],
    "l": 1
  }, {
    "p": [56, 0, -249],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [62, 0, -348],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [86, 0, -297],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [86, 0, -292],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-220, 0, -104],
    "s": [57, 26, 25],
    "i": 17,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-227, 0, -139],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [78, 0, -203],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-173, 0, -70],
    "s": [4, 1, 4],
    "l": 1
  }, {
    "p": [169, 0, 17],
    "s": [6, 2, 8],
    "l": 1
  }, {
    "p": [147, 0, 28],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [289, 10, -542],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [295, 10, -542],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-181, 0, -473],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-52, 21, -269],
    "s": [1, 15, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-52, 29, -218],
    "s": [1, 15, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-53, 18, -269],
    "s": [6, 3, 9],
    "l": 1,
    "c": 14935011
  }, {
    "p": [-53, 26, -218],
    "s": [6, 3, 9],
    "l": 1,
    "c": 14935011
  }, {
    "p": [217, 67, -541],
    "s": [6, 3, 9],
    "c": 14935011,
    "bo": 1
  }, {
    "p": [304, 76, -518],
    "s": [6, 3, 9],
    "c": 11645361,
    "bo": 1
  }, {
    "p": [90, 44, -195],
    "s": [16, 2, 4],
    "l": 1
  }, {
    "p": [127, 44, -195],
    "s": [26, 4, 4],
    "l": 1
  }, {
    "p": [66, 44, -195],
    "s": [12, 3, 4],
    "l": 1
  }, {
    "p": [-317, 0, -415],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-53, 0, -159],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d5e371"
  }, {
    "p": [-54, 0, -169],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.04, -3.14],
    "c": "#d5e371"
  }, {
    "p": [36, 0, -165],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#d5e371"
  }, {
    "p": [37, 0, -175],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.18, 0],
    "c": "#d5e371"
  }, {
    "p": [5, 0, -188],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.09, -3.14],
    "c": "#d5e371"
  }, {
    "p": [-42, 0, -57],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.18, 0],
    "c": "#c9d47c"
  }, {
    "p": [-9, 0, 2],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.18, 0],
    "c": "#c9d47c"
  }, {
    "p": [-19, 0, -26],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.18, 0],
    "c": "#c9d47c"
  }, {
    "p": [21, 0, -346],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [59, 0, -344],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [80, 0, -212],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [29, 0, -346],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0]
  }, {
    "p": [129, 0, -286],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [101, 0, -318],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [59, 0, -243],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.04, 0]
  }, {
    "p": [139, 0, -231],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [-42, -28, -355],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.18, 0]
  }, {
    "p": [-5, -28, -347],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0]
  }, {
    "p": [-86, -28, -325],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [-260, 0, -269],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-298, 0, -236],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-307, 0, -275],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-182, 0, -271],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [-176, 0, -264],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-217, 0, -136],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-214, 0, -72],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-147, 0, -149],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-109, 0, -62],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-109, 18, -25],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-215, 18, 19],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-230, 18, 43],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0]
  }, {
    "p": [-46, 18, 54],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.22, -3.14]
  }, {
    "p": [10, 18, 54],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-48, 18, 16],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0]
  }, {
    "p": [160, 0, -62],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [169, 0, -27],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0],
    "c": "#c9d47c"
  }, {
    "p": [162, 0, 20],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0],
    "c": "#c9d47c"
  }, {
    "p": [173, 0, 11],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.38, 0],
    "c": "#c9d47c"
  }, {
    "p": [166, 0, -92],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [126, 0, -150],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [127, 0, -65],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0],
    "c": "#c9d47c"
  }, {
    "p": [134, 0, -70],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#c9d47c"
  }, {
    "p": [128, 0, -77],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.23, 3.14],
    "c": "#c9d47c"
  }, {
    "p": [96, 0, -46],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0],
    "c": "#c9d47c"
  }, {
    "p": [130, 0, -71],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [174, 0, 20],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0],
    "c": "#c9d47c"
  }, {
    "p": [11, 0, 3],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0],
    "c": "#c9d47c"
  }, {
    "p": [206, 0, -218],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [208, 0, -186],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.51, 0]
  }, {
    "p": [174, 0, -156],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.51, 0]
  }, {
    "p": [101, 0, 2],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [205, 0, -279],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [237, 0, -283],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.88, 0],
    "c": "#c9d47c"
  }, {
    "p": [307, -1, -247],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.41, 3.14],
    "c": "#c9d47c"
  }, {
    "p": [253, 0, -108],
    "s": [6, 1, 6],
    "l": 1
  }, {
    "p": [306, 0, -316],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0],
    "c": "#c9d47c"
  }, {
    "p": [274, 0, -350],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.13, -1.41, -3.13]
  }, {
    "p": [320, 1, -440],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [320, 1, -420],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [319, 1, -430],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.56, 0]
  }, {
    "p": [322, 1, -372],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.04, 0]
  }, {
    "p": [318, 1, -385],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.39, 0]
  }, {
    "p": [326, 1, -389],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [329, 1, -361],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [251, 0, -357],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [327, 1, -422],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.39, 0]
  }, {
    "p": [318, 1, -395],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.18, 3.14]
  }, {
    "p": [326, 1, -434],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-0.1, -1.56, -0.1]
  }, {
    "p": [301, 10, -541],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [222, 10, -511],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [221, 10, -467],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [-40, -28, -362],
    "s": [4, 1, 6]
  }, {
    "p": [-214, 0, -68],
    "s": [2, 1, 2],
    "l": 1
  }, {
    "p": [-280, 0, -296],
    "s": [3, 1, 4],
    "l": 1
  }, {
    "p": [195, 0, -284],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [305, 0, -307],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.88, 0],
    "c": "#c9d47c"
  }, {
    "p": [164, -28, -429],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.36, -3.14]
  }, {
    "p": [105, -28, -456],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.88, -3.14]
  }, {
    "p": [129, -28, -455],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.88, -3.14]
  }, {
    "p": [222, 10, -529],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [220, 10, -543],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.51, -3.14]
  }, {
    "p": [61, -29, -435],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [276, 0, -346],
    "s": [2, 1, 3],
    "l": 1
  }, {
    "p": [134, 0, -77],
    "s": [2, 1, 3],
    "l": 1
  }, {
    "p": [-157, 0, -147],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-247, 0, -271],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [50, -28, -423],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.88, -3.14]
  }, {
    "p": [53, -28, -511],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [49, -28, -517],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.51, 0]
  }, {
    "p": [-15, -28, -517],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.06, 0]
  }, {
    "p": [-21, -28, -512],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.16, 0]
  }, {
    "p": [-32, -28, -505],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.56, -3.14]
  }, {
    "p": [6, -28, -462],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.21, -3.14]
  }, {
    "p": [11, 0, -186],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.04, -3.14],
    "c": "#d5e371"
  }, {
    "p": [3, -28, -315],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0]
  }, {
    "p": [-6, -28, -318],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.39, 0]
  }, {
    "p": [2, -28, -347],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.22, 0]
  }, {
    "p": [-67, -28, -325],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [3, -28, -422],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.21, -3.14]
  }, {
    "p": [-187, 0, -477],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-316, 0, -368],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-316, 0, -376],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-315, 0, -410],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.7, -3.14]
  }, {
    "p": [-175, 0, -398],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [-186, 0, -499],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [-245, 0, -360],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [-2, -28, -417],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.16, -3.14]
  }, {
    "p": [-249, 0, -434],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.7, -3.14]
  }, {
    "p": [-194, 0, -476],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.52, 3.14]
  }, {
    "p": [133, 0, -224],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [293, 39, -301],
    "s": [1, 10, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [-165, 18, -33],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [71, 0, -274],
    "s": [57, 26, 25],
    "i": 19,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [71, 0, -274],
    "s": [25, 2, 57],
    "v": 1,
    "t": 5
  }, {
    "p": [71, 24, -274],
    "s": [25, 2, 57],
    "v": 1,
    "t": 5
  }, {
    "p": [59, 2, -274],
    "s": [1, 22, 57],
    "pe": 1,
    "v": 1,
    "t": 5
  }, {
    "p": [83, 2, -274],
    "s": [1, 22, 57],
    "pe": 1,
    "v": 1,
    "t": 5
  }, {
    "p": [71, -1, -274],
    "s": [22, 2, 54],
    "c": 7677719,
    "t": 5
  }, {
    "p": [-52, -28, -322],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-48, -28, -315],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [87, 0, -287],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [251, 0, -414],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [68, 0, -114],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [228, 48, -124],
    "s": [10, 2, 6],
    "l": 1
  }, {
    "p": [223, 0, -143],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [261, 0, -321],
    "s": [57, 26, 25],
    "i": 19,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [261, 0, -321],
    "s": [25, 2, 57],
    "v": 1,
    "t": 5
  }, {
    "p": [261, 24, -321],
    "s": [25, 2, 57],
    "pe": 1,
    "v": 1,
    "t": 5
  }, {
    "p": [273, 2, -321],
    "s": [1, 22, 57],
    "pe": 1,
    "v": 1,
    "t": 5
  }, {
    "p": [249, 2, -321],
    "s": [1, 22, 55],
    "pe": 1,
    "t": 5
  }, {
    "p": [261, 0, -321],
    "s": [23, 1, 54],
    "c": 9518129,
    "t": 5
  }, {
    "p": [275, 0, -291],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.19, -3.14],
    "c": "#c9d47c"
  }, {
    "p": [-202, 0, -485],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-190, 12, -485],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-187, 0, -494],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-156, 0, -514],
    "s": [57, 26, 25],
    "i": 19,
    "l": 1
  }, {
    "p": [-156, 0, -527],
    "s": [57, 52, 2],
    "c": 1776411,
    "t": 5
  }, {
    "p": [-153, 0, -514],
    "s": [63, 1, 23],
    "c": 1776411,
    "t": 5
  }, {
    "p": [-217, 0, -544],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.52, 3.14]
  }, {
    "p": [-187, 0, -524],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.52, 3.14]
  }, {
    "p": [-155, 1, -502],
    "s": [54, 24, 2],
    "v": 1,
    "c": 1776411,
    "t": 5
  }, {
    "p": [-155, 24, -514],
    "s": [57, 2, 25],
    "pe": 1,
    "v": 1,
    "c": 1776411,
    "t": 5
  }, {
    "p": [-245, 0, -453],
    "s": [4, 11, 23]
  }, {
    "p": [324, -18, -158],
    "s": [4, 25, 80]
  }, {
    "p": [260, -18, -158],
    "s": [4, 25, 80]
  }, {
    "p": [292, -14, -175],
    "s": [61, 14, 44],
    "i": 9,
    "c": "#ffffff",
    "t": 1,
    "d": 3
  }, {
    "p": [-305, 10, -521],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-270, 10, -445],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-265, 0, -375],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-165, 0, -404],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-275, 0, -453],
    "s": [4, 16, 24]
  }, {
    "p": [324, 7, -150],
    "s": [4, 2, 22]
  }, {
    "p": [324, 7, -182],
    "s": [4, 2, 16]
  }, {
    "p": [-245, 16, -522],
    "s": [4, 2, 12]
  }, {
    "p": [-245, 16, -479],
    "s": [4, 2, 12]
  }, {
    "p": [-245, 0, -507],
    "s": [4, 16, 80]
  }, {
    "p": [-245, 0, -467],
    "s": [5, 17, 5]
  }, {
    "p": [-275, 16, -451],
    "s": [4, 2, 12]
  }, {
    "p": [228, 0, -98],
    "s": [10, 48, 18],
    "bo": 1
  }, {
    "p": [292, -1, -112],
    "s": [68, 1, 22],
    "t": 1
  }, {
    "p": [292, -18, -121],
    "s": [60, 19, 6],
    "c": "#525252",
    "t": 5
  }, {
    "p": [228, 20, -109],
    "s": [10, 28, 4],
    "bo": 1
  }, {
    "p": [292, 36, -64],
    "s": [50, 2, 80],
    "c": "#3e3e3e",
    "t": 5,
    "bo": 1
  }, {
    "p": [292, -3, -73],
    "s": [50, 4, 90],
    "c": "#525252",
    "t": 5
  }, {
    "p": [259, 0, -63],
    "s": [18, 37, 80],
    "bo": 1
  }, {
    "p": [380, 0, -63],
    "s": [128, 37, 80],
    "bo": 1
  }, {
    "p": [305, 10, -69],
    "s": [66, 22, 2],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [292, 10, -69],
    "s": [66, 2, 24],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": 2899797,
    "t": 5
  }, {
    "p": [292, 32, -69],
    "s": [66, 2, 28],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [292, 3, -78],
    "s": [4, 4, 27],
    "r": [0, -1.57, 0],
    "c": 8551805,
    "t": 5
  }, {
    "p": [303, 1, -78],
    "s": [8, 8, 4],
    "r": [0, -1.57, 0],
    "c": 1447446,
    "t": 5
  }, {
    "p": [298, 1, -78],
    "s": [8, 8, 4],
    "r": [0, -1.57, 0],
    "c": 1447446,
    "t": 5
  }, {
    "p": [281, 1, -78],
    "s": [8, 8, 4],
    "r": [0, -1.57, 0],
    "c": 1447446,
    "t": 5
  }, {
    "p": [286, 1, -78],
    "s": [8, 8, 4],
    "r": [0, -1.57, 0],
    "c": 1447446,
    "t": 5
  }, {
    "p": [292, 6, -67],
    "s": [66, 4, 5],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": 8551805,
    "t": 5
  }, {
    "p": [292, 6, -101],
    "s": [3, 4, 24],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": 8551805,
    "t": 5
  }, {
    "p": [285, 12, -102],
    "s": [2, 20, 12],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#6b6b6b",
    "t": 5
  }, {
    "p": [306, 12, -97],
    "s": [12, 20, 2],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#6b6b6b",
    "t": 5
  }, {
    "p": [292, 5, -101],
    "s": [4, 1, 27],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": 8551805,
    "t": 5
  }, {
    "p": [282, 7, -102],
    "s": [2, 2, 2],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": 16730880,
    "e": 16711680,
    "o": 0.8,
    "t": 5
  }, {
    "p": [302, 7, -102],
    "s": [2, 2, 2],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#ff4b00",
    "e": 16711680,
    "o": 0.8,
    "t": 5
  }, {
    "p": [316, 0, -64],
    "s": [2, 36, 80],
    "c": "#3e3e3e",
    "t": 5,
    "bo": 1
  }, {
    "p": [292, 0, -38],
    "s": [46, 36, 1],
    "c": 0,
    "t": 5
  }, {
    "p": [292, 0, -57],
    "s": [46, 36, 1],
    "c": 0,
    "o": 0.4,
    "t": 5
  }, {
    "p": [292, 0, -73],
    "s": [46, 36, 1],
    "c": 0,
    "o": 0.4,
    "t": 5
  }, {
    "p": [292, 0, -73],
    "s": [46, 36, 1],
    "c": 0,
    "o": 0.4,
    "t": 5
  }, {
    "p": [292, -18, -139],
    "s": [60, 4, 30],
    "c": "#b6b6b6",
    "t": 1
  }, {
    "p": [292, 0, -103],
    "s": [46, 36, 1],
    "c": 0,
    "o": 0.4,
    "t": 5,
    "bo": 1
  }, {
    "p": [292, 0, -91],
    "s": [46, 36, 1],
    "c": 0,
    "o": 0.4,
    "t": 5
  }, {
    "p": [228, 0, -142],
    "s": [10, 48, 14],
    "bo": 1
  }, {
    "p": [228, 19, -133],
    "s": [10, 29, 4],
    "bo": 1
  }, {
    "p": [228, 26, -121],
    "s": [10, 22, 20],
    "bo": 1
  }, {
    "p": [222, 0, -131],
    "s": [7, 1, 4],
    "l": 1
  }, {
    "p": [-156, 0, -488],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [-265, 10, -443],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [320, 0, -121],
    "s": [2, 50, 2],
    "t": 2
  }, {
    "p": [317, -14, -130],
    "s": [4, 1, 4],
    "l": 1,
    "c": "#c5c5c5"
  }, {
    "p": [313, 1, -100],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [315, 1, -119],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-54, 0, -118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#d5e371"
  }, {
    "p": [236, 0, -94],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [236, 0, -144],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [-253, 73, -557],
    "s": [69, 0, 28],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "sad": 1
  }, {
    "p": [-250, 10, -544],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-129, 2, -514],
    "s": [1, 24, 23],
    "l": 1,
    "c": 0,
    "o": 0.7000000000000001,
    "t": 5
  }, {
    "p": [-122, 58, -524],
    "s": [6, 14, 6],
    "t": 2
  }, {
    "p": [-83, 62, -459],
    "s": [6, 16, 6],
    "t": 2
  }, {
    "p": [-156, 26, -514],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [-136, -28, -350],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0]
  }, {
    "p": [176, 0, -10],
    "s": [2, 18, 4],
    "c": 14145495,
    "t": 2
  }, {
    "p": [-56, 0, -128],
    "s": [2, 18, 4],
    "c": 14145495,
    "t": 2
  }, {
    "p": [138, 0, -286],
    "s": [5, 19, 2],
    "t": 2
  }, {
    "p": [145, 0, -286],
    "s": [5, 18, 2],
    "t": 2
  }, {
    "p": [26, 0, -350],
    "s": [5, 18, 2],
    "t": 2
  }, {
    "p": [309, 0, -306],
    "s": [2, 19, 4],
    "t": 2
  }, {
    "p": [308, 0, -316],
    "s": [2, 19, 4],
    "t": 2
  }, {
    "p": [-260, 0, -439],
    "s": [26, 16, 4]
  }, {
    "p": [-269, 10, -452],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.7, -3.14]
  }, {
    "p": [-212, 0, -385],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-212, 0, -384],
    "s": [49, 8, 16],
    "v": 1
  }, {
    "p": [-217, 8, -384],
    "s": [24, 7, 16],
    "v": 1
  }, {
    "p": [-155, 0, -412],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.87, 3.14]
  }, {
    "p": [-241, 0, -388],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [-192, 0, -371],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [279, 10, -69],
    "s": [66, 22, 2],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [343, 32, -376],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [343, 44, -369],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [183, 88, -4],
    "s": [4, 2, 54],
    "t": 2
  }, {
    "p": [199, 88, -4],
    "s": [4, 2, 54],
    "t": 2
  }, {
    "p": [190, 90, -27],
    "s": [26, 1, 4],
    "c": 14277081,
    "t": 2
  }, {
    "p": [190, 90, -20],
    "s": [25, 1, 4],
    "t": 2
  }, {
    "p": [191, 90, -12],
    "s": [26, 1, 4],
    "c": 13158600,
    "t": 2
  }, {
    "p": [191, 90, 19],
    "s": [26, 1, 4],
    "t": 2
  }, {
    "p": [190, 90, -5],
    "s": [24, 1, 4],
    "t": 2
  }, {
    "p": [190, 90, 12],
    "s": [23, 1, 4],
    "t": 2
  }, {
    "p": [190, 90, 4],
    "s": [23, 1, 4],
    "c": 12303291,
    "t": 2
  }, {
    "p": [170, 87, -87],
    "s": [6, 19, 6],
    "t": 2
  }, {
    "p": [177, 43, -5],
    "s": [2, 13, 4],
    "l": 1,
    "c": 0
  }, {
    "p": [318, 1, -403],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [324, 1, -410],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [146, 0, 51],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [18, 28, -520],
    "s": [11, 3, 3],
    "bo": 1
  }, {
    "p": [-17, 31, -520],
    "s": [11, 3, 3],
    "bo": 1
  }, {
    "p": [51, 31, -520],
    "s": [11, 3, 3],
    "bo": 1
  }, {
    "p": [18, 31, -521],
    "s": [7, 16, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [51, 34, -521],
    "s": [7, 16, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [-17, 34, -521],
    "s": [7, 16, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [150, 7, -425],
    "s": [18, 7, 4]
  }, {
    "p": [100, 7, -425],
    "s": [10, 7, 4]
  }, {
    "p": [101, 10, -461],
    "s": [8, 6, 4]
  }, {
    "p": [112, -28, -461],
    "s": [58, 36, 4]
  }, {
    "p": [123, 4, -443],
    "s": [36, 1, 32]
  }, {
    "p": [143, 4, -443],
    "s": [4, 10, 32]
  }, {
    "p": [103, 4, -443],
    "s": [4, 10, 32]
  }, {
    "p": [143, 14, -435],
    "s": [4, 2, 9]
  }, {
    "p": [103, 14, -449],
    "s": [4, 2, 9]
  }, {
    "p": [103, 14, -433],
    "s": [4, 2, 9]
  }, {
    "p": [123, 8, -443],
    "s": [36, 2, 36],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [152, 14, -425],
    "s": [8, 2, 4]
  }, {
    "p": [139, 1, -444],
    "s": [4, 3, 34],
    "t": 2
  }, {
    "p": [107, 1, -444],
    "s": [4, 3, 34],
    "t": 2
  }, {
    "p": [139, -1, -455],
    "s": [2, 2, 14],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": 13948116,
    "t": 2
  }, {
    "p": [107, -1, -455],
    "s": [2, 2, 14],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": 14277081,
    "t": 2
  }, {
    "p": [107, -1, -429],
    "s": [2, 2, 14],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": 15132390,
    "t": 2
  }, {
    "p": [139, -1, -430],
    "s": [2, 2, 14],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": 14803425,
    "t": 2
  }, {
    "p": [154, 8, -408],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [101, 8, -419],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-241, 0, -453],
    "s": [4, 8, 25],
    "l": 1
  }, {
    "p": [-237, 0, -453],
    "s": [4, 5, 25],
    "l": 1
  }, {
    "p": [-233, 0, -453],
    "s": [4, 2, 25]
  }, {
    "p": [-236, 0, -453],
    "s": [14, 11, 23],
    "i": 9,
    "v": 1,
    "t": 1,
    "d": 2
  }, {
    "p": [-193, 0, -494],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.53, 3.14]
  }, {
    "p": [369, 81, -121],
    "s": [4, 3, 17],
    "l": 1
  }, {
    "p": [-148, 101, 97],
    "s": [20, 2, 4],
    "l": 1
  }, {
    "p": [-238, -1, -586],
    "s": [175, 90, 11]
  }, {
    "p": [-280, 89, -586],
    "s": [22, 4, 11],
    "l": 1
  }, {
    "p": [-252, 50, 27],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [248, 15, -574],
    "s": [129, 75, 11]
  }, {
    "p": [223, 90, -574],
    "s": [21, 3, 11],
    "l": 1
  }, {
    "p": [253, 90, -574],
    "s": [21, 2, 11],
    "l": 1
  }, {
    "p": [287, 90, -574],
    "s": [17, 4, 11],
    "l": 1
  }, {
    "p": [-249, 124, -103],
    "s": [12, 4, 12],
    "l": 1,
    "c": 12499642
  }, {
    "p": [-246, 124, -84],
    "s": [6, 2, 12],
    "l": 1,
    "c": 14145495
  }, {
    "p": [-178, 101, 97],
    "s": [13, 2, 4],
    "l": 1
  }, {
    "p": [-207, 101, 97],
    "s": [13, 3, 4],
    "l": 1
  }, {
    "p": [-237, 101, 97],
    "s": [16, 2, 4],
    "l": 1
  }, {
    "p": [-260, 101, 73],
    "s": [4, 2, 17],
    "l": 1
  }, {
    "p": [-260, 101, 41],
    "s": [4, 2, 13],
    "l": 1
  }, {
    "p": [-260, 101, 12],
    "s": [4, 3, 11],
    "l": 1
  }, {
    "p": [-260, 101, -21],
    "s": [4, 2, 23],
    "l": 1
  }, {
    "p": [-243, 91, -84],
    "s": [6, 3, 10],
    "c": 12171705
  }, {
    "p": [-159, 77, -156],
    "s": [14, 4, 6],
    "l": 1
  }, {
    "p": [-185, 77, -156],
    "s": [11, 3, 6],
    "l": 1
  }, {
    "p": [-220, 77, -158],
    "s": [14, 3, 10],
    "l": 1
  }, {
    "p": [-278, 77, -226],
    "s": [23, 4, 6],
    "l": 1
  }, {
    "p": [-310, 77, -156],
    "s": [27, 2, 6],
    "l": 1
  }, {
    "p": [357, 98, -450],
    "s": [16, 3, 16],
    "l": 1
  }, {
    "p": [352, 98, -487],
    "s": [6, 4, 12],
    "l": 1
  }, {
    "p": [369, 81, -235],
    "s": [4, 3, 17],
    "l": 1
  }, {
    "p": [369, 81, -202],
    "s": [4, 2, 11],
    "l": 1
  }, {
    "p": [369, 81, -165],
    "s": [4, 2, 21],
    "l": 1
  }, {
    "p": [328, 37, -63],
    "s": [156, 44, 80],
    "bo": 1
  }, {
    "p": [347, 81, -101],
    "s": [13, 2, 4],
    "l": 1
  }, {
    "p": [257, 81, -100],
    "s": [14, 3, 6],
    "l": 1
  }, {
    "p": [318, 81, -101],
    "s": [16, 3, 4],
    "l": 1
  }, {
    "p": [285, 81, -101],
    "s": [14, 3, 4],
    "l": 1
  }, {
    "p": [361, 50, -188],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [361, 50, -176],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-242, 89, -586],
    "s": [22, 3, 11],
    "l": 1
  }, {
    "p": [-200, 89, -586],
    "s": [18, 4, 11],
    "l": 1
  }, {
    "p": [-256, 77, -156],
    "s": [17, 4, 6],
    "l": 1
  }, {
    "p": [-234, 77, -226],
    "s": [16, 4, 6],
    "l": 1
  }, {
    "p": [-319, 77, -226],
    "s": [20, 3, 6],
    "l": 1
  }, {
    "p": [-193, 77, -226],
    "s": [19, 2, 6],
    "l": 1
  }, {
    "p": [-151, 77, -226],
    "s": [19, 3, 6],
    "l": 1
  }, {
    "p": [-171, 18, 51],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-118, 116, -197],
    "s": [9, 3, 52],
    "c": 11513775
  }, {
    "p": [-118, 116, -197],
    "s": [52, 3, 9],
    "c": 9868950
  }, {
    "p": [-143, 0, -49],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.05, -3.14]
  }, {
    "p": [-348, 153, -230],
    "s": [11, 4, 12],
    "l": 1
  }, {
    "p": [-349, 153, -276],
    "s": [13, 4, 12],
    "l": 1
  }, {
    "p": [-392, 153, -230],
    "s": [11, 4, 12],
    "l": 1
  }, {
    "p": [-390, 153, -276],
    "s": [15, 4, 12],
    "l": 1
  }, {
    "p": [-370, 110, -253],
    "s": [72, 2, 76],
    "t": 2
  }, {
    "p": [-370, 106, -253],
    "s": [67, 4, 4],
    "t": 2
  }, {
    "p": [-370, 106, -235],
    "s": [67, 4, 4],
    "t": 2
  }, {
    "p": [-370, 106, -272],
    "s": [67, 4, 4],
    "t": 2
  }, {
    "p": [-370, 106, -253],
    "s": [4, 4, 72],
    "t": 2
  }, {
    "p": [-354, 106, -253],
    "s": [4, 4, 72],
    "t": 2
  }, {
    "p": [-387, 106, -253],
    "s": [4, 4, 72],
    "t": 2
  }, {
    "p": [-343, 123, -254],
    "s": [2, 16, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-345, 153, -252],
    "s": [5, 3, 12],
    "l": 1
  }, {
    "p": [-368, 153, -226],
    "s": [14, 2, 4],
    "l": 1
  }, {
    "p": [-368, 153, -280],
    "s": [11, 3, 4],
    "l": 1
  }, {
    "p": [-319, 103, -587],
    "s": [62, 2, 67],
    "c": 12500670,
    "t": 2
  }, {
    "p": [-319, 100, -587],
    "s": [4, 3, 63],
    "c": 14802654,
    "t": 2
  }, {
    "p": [-334, 100, -587],
    "s": [4, 3, 63],
    "c": 14276053,
    "t": 2
  }, {
    "p": [-303, 100, -587],
    "s": [4, 3, 63],
    "c": 14474460,
    "t": 2
  }, {
    "p": [-319, 100, -587],
    "s": [58, 3, 3],
    "c": 12829635,
    "t": 2
  }, {
    "p": [-319, 100, -569],
    "s": [58, 3, 3],
    "c": 13158600,
    "t": 2
  }, {
    "p": [-319, 100, -603],
    "s": [58, 3, 3],
    "c": 13619151,
    "t": 2
  }, {
    "p": [183, 85, -28],
    "s": [2, 2, 11],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [199, 85, -28],
    "s": [2, 2, 11],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [199, 85, 20],
    "s": [2, 2, 11],
    "l": 1,
    "r": [0.7, 0, 0],
    "t": 2
  }, {
    "p": [183, 85, 20],
    "s": [2, 2, 11],
    "l": 1,
    "r": [0.7, 0, 0],
    "t": 2
  }, {
    "p": [270, -14, -130],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-231, 0, -398],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.05, 0]
  }, {
    "p": [-202, 0, -397],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.05, 0]
  }, {
    "p": [-260, 16, -439],
    "s": [12, 2, 4]
  }, {
    "p": [-245, 0, -439],
    "s": [5, 17, 5]
  }, {
    "p": [-275, 0, -439],
    "s": [5, 17, 5]
  }, {
    "p": [-236, 0, -467],
    "s": [14, 13, 3]
  }, {
    "p": [-236, 0, -439],
    "s": [14, 13, 3]
  }, {
    "p": [-239, 0, -472],
    "s": [6, 8, 6],
    "i": 2,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-229, 0, -439],
    "s": [4, 14, 4]
  }, {
    "p": [-229, 0, -467],
    "s": [4, 14, 4]
  }, {
    "p": [-178, 0, -361],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [-203, 0, -372],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0.01, -1.39, 0.01]
  }, {
    "p": [-221, 0, -371],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0.01, -1.39, 0.01]
  }, {
    "p": [-232, 1, -372],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.23, 0.01]
  }, {
    "p": [-184, 0, -388],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0]
  }, {
    "p": [-185, 0, -378],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.88, -3.14]
  }, {
    "p": [-227, 0, -357],
    "s": [4, 19, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-217, 0, -356],
    "s": [4, 19, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-222, 0, -357],
    "s": [4, 14, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [144, -28, -455],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.21, 0]
  }, {
    "p": [-239, 0, -479],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.88, 0]
  }, {
    "p": [260, 7, -182],
    "s": [4, 2, 16]
  }, {
    "p": [260, 7, -150],
    "s": [4, 2, 22]
  }, {
    "p": [335, 139, -35],
    "s": [12, 4, 6],
    "l": 1
  }, {
    "p": [362, 139, -62],
    "s": [6, 4, 12],
    "l": 1
  }, {
    "p": [212, 16, -461],
    "s": [20, 2, 4]
  }, {
    "p": [143, 14, -450],
    "s": [4, 2, 9]
  }, {
    "p": [268, 0, -64],
    "s": [2, 36, 80],
    "c": "#3e3e3e",
    "t": 5,
    "bo": 1
  }, {
    "p": [-69, -32, -345],
    "s": [150, 4, 76],
    "t": 1
  }, {
    "p": [-196, -2, -213],
    "s": [34, 2, 32],
    "t": 1
  }, {
    "p": [-210, 42, -361],
    "s": [76, 1, 12],
    "t": 2,
    "bo": 1
  }, {
    "p": [-247, 38, -360],
    "s": [2, 2, 12],
    "l": 1,
    "r": [0.7, 0, 0],
    "t": 2
  }, {
    "p": [-210, 38, -360],
    "s": [2, 2, 12],
    "l": 1,
    "r": [0.7, 0, 0],
    "t": 2
  }, {
    "p": [-174, 38, -360],
    "s": [2, 2, 12],
    "l": 1,
    "r": [0.7, 0, 0],
    "t": 2
  }, {
    "p": [-178, 43, -362],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-184, 43, -360],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-180, 51, -360],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-228, 28, -368],
    "s": [1, 13, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [-215, 0, -395],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.05, 0]
  }, {
    "p": [-415, 0, -444],
    "s": [58, 127, 90],
    "c": 10986917
  }, {
    "p": [-394, 127, -406],
    "s": [16, 3, 14],
    "l": 1,
    "c": 11645361
  }, {
    "p": [-394, 127, -481],
    "s": [16, 4, 16],
    "l": 1,
    "c": 11645361
  }, {
    "p": [-394, 127, -444],
    "s": [16, 3, 16],
    "l": 1,
    "c": 11184810
  }, {
    "p": [-434, 127, -407],
    "s": [20, 3, 16],
    "l": 1,
    "c": 10855331
  }, {
    "p": [-436, 127, -481],
    "s": [16, 3, 16],
    "l": 1,
    "c": 11645361
  }, {
    "p": [-210, 41, -368],
    "s": [76, 2, 2],
    "t": 2,
    "bo": 1
  }, {
    "p": [-345, 72, -526],
    "s": [40, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 72, -540],
    "s": [40, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 72, -533],
    "s": [3, 3, 40],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-352, 90, -526],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 72, -526],
    "s": [3, 42, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-337, 90, -526],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-337, 90, -540],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-352, 90, -540],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 72, -540],
    "s": [3, 38, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 86, -533],
    "s": [3, 3, 33],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 86, -540],
    "s": [21, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 86, -526],
    "s": [21, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 72, -514],
    "s": [3, 17, 3],
    "l": 1,
    "r": [-0.26, 0, 0],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 72, -552],
    "s": [3, 17, 3],
    "l": 1,
    "r": [0.26, 0, 0],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 98, -362],
    "s": [40, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 98, -376],
    "s": [40, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 98, -369],
    "s": [3, 3, 40],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-363, 116, -362],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 98, -362],
    "s": [3, 42, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-348, 116, -362],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-348, 116, -376],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-363, 116, -376],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 98, -376],
    "s": [3, 42, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 112, -369],
    "s": [3, 3, 33],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 112, -376],
    "s": [21, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 112, -362],
    "s": [21, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 140, -369],
    "s": [3, 3, 20],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-359, 125, -369],
    "s": [9, 11, 6],
    "c": "#757575"
  }, {
    "p": [-346, 151, -369],
    "s": [41, 3, 3],
    "l": 1,
    "r": [0, 0, -2.45],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-327, 164, -369],
    "s": [5, 2, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-326, 132, -369],
    "s": [1, 34, 1],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-326, 129, -369],
    "s": [2, 3, 2],
    "c": "#343434",
    "t": 5
  }, {
    "p": [-356, 98, -350],
    "s": [3, 17, 3],
    "l": 1,
    "r": [-0.26, 0, 0],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 98, -388],
    "s": [3, 17, 3],
    "l": 1,
    "r": [0.26, 0, 0],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-360, 136, -369],
    "s": [5, 3, 6],
    "c": "#757575"
  }, {
    "p": [-386, 90, -445],
    "s": [2, 19, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-386, 88, -445],
    "s": [6, 4, 12],
    "c": 11183011
  }, {
    "p": [-216, 48, -63],
    "s": [8, 2, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "t": 2
  }, {
    "p": [-207, 34, -63],
    "s": [1, 18, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [378, 98, -463],
    "s": [40, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 98, -477],
    "s": [40, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 98, -470],
    "s": [3, 3, 40],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [371, 116, -463],
    "s": [40, 3, 3],
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 98, -463],
    "s": [3, 42, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [386, 116, -463],
    "s": [40, 3, 3],
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [386, 116, -477],
    "s": [40, 3, 3],
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [371, 116, -477],
    "s": [40, 3, 3],
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 98, -477],
    "s": [3, 42, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 112, -470],
    "s": [3, 3, 33],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 112, -477],
    "s": [21, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 112, -463],
    "s": [21, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 140, -470],
    "s": [3, 3, 20],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [383, 125, -470],
    "s": [9, 11, 6],
    "c": "#757575"
  }, {
    "p": [367, 150, -470],
    "s": [41, 3, 3],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [353, 165, -470],
    "s": [5, 2, 2],
    "l": 1,
    "r": [0, 0, 2.45],
    "c": "#522505",
    "t": 5
  }, {
    "p": [351, 131, -470],
    "s": [1, 34, 1],
    "c": "#522505",
    "t": 5
  }, {
    "p": [351, 128, -470],
    "s": [2, 3, 2],
    "c": "#343434",
    "t": 5
  }, {
    "p": [378, 98, -451],
    "s": [3, 17, 3],
    "r": [-0.26, 0, 0],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 98, -489],
    "s": [3, 17, 3],
    "r": [0.26, 0, 0],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [383, 136, -470],
    "s": [5, 3, 6],
    "c": "#757575"
  }, {
    "p": [311, 112, -508],
    "s": [14, 4, 22],
    "l": 1,
    "c": "#b1b1b1"
  }, {
    "p": [347, 112, -500],
    "s": [22, 3, 6],
    "l": 1,
    "c": "#b1b1b1"
  }, {
    "p": [307, 112, -539],
    "s": [6, 3, 18],
    "l": 1,
    "c": "#b1b1b1"
  }, {
    "p": [253, 0, -457],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.04, 0]
  }, {
    "p": [219, 0, -106],
    "s": [4, 2, 3],
    "l": 1
  }, {
    "p": [234, 0, -112],
    "s": [3, 1, 4],
    "l": 1
  }, {
    "p": [219, 0, -142],
    "s": [3, 1, 4],
    "l": 1
  }, {
    "p": [313, 58, -449],
    "s": [6, 10, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [393, 64, -477],
    "s": [88, 34, 70]
  }, {
    "p": [385, 98, -444],
    "s": [18, 3, 4],
    "l": 1
  }, {
    "p": [411, 98, -444],
    "s": [16, 3, 4],
    "l": 1
  }, {
    "p": [432, 98, -447],
    "s": [10, 3, 10],
    "l": 1
  }, {
    "p": [388, 89, -435],
    "s": [4, 4, 16],
    "t": 2
  }, {
    "p": [388, 85, -441],
    "s": [2, 2, 14],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [282, -14, -128],
    "s": [7, 1, 4],
    "l": 1,
    "c": "#c5c5c5"
  }, {
    "p": [179, 67, -24],
    "s": [4, 5, 15],
    "l": 1
  }, {
    "p": [-224, 0, -104],
    "s": [31, 24, 54],
    "c": 4276545,
    "t": 5
  }, {
    "p": [-18, 18, 36],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": 0
  }, {
    "p": [-276, 10, -518],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": "1"
  }, {
    "p": [96, 8, -421],
    "s": [2, 6, 4],
    "pe": 1,
    "v": 1
  }, {
    "p": [221, 0, -97],
    "s": [4, 12, 12],
    "pe": 1,
    "v": 1
  }, {
    "p": [320, 0, -120],
    "s": [4, 7, 4],
    "pe": 1,
    "v": 1
  }, {
    "p": [138, 0, -150],
    "s": [4, 8, 6],
    "pe": 1,
    "v": 1
  }, {
    "p": [-156, 26, -514],
    "s": [57, 1, 26],
    "v": 1,
    "bo": 1
  }, {
    "p": [-306, 10, -511],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.7, -3.14]
  }, {
    "p": [-253, 10, -542],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.17, -3.14]
  }, {
    "p": [-304, 10, -542],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.17, -3.14]
  }, {
    "p": [-252, 10, -475],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.17, -3.14]
  }, {
    "p": [93, 24, -69],
    "s": [2, 26, 62],
    "c": 6903619,
    "t": 5,
    "bo": 1
  }, {
    "p": [95, 37, -69],
    "s": [57, 0, 23],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "sad": 1
  }]
}